import { dialog } from '@forest/shared/solid'
import { m } from '~/paraglide/messages'

/**
 * The Daily Picks explainer (GLOSSARY.md "Daily pick collection"): the
 * dialog the section heading opens, saying what the assortment is and when
 * it rotates. Nothing but copy — no title, a plain dialog Escape can
 * dismiss, and an OK that only closes it.
 */
export function openDailyPicksInfo(): Promise<void> {
  return dialog.open({
    button: m.ok(),
    buttonTestId: 'daily-picks-info-dismiss',
    description: m.dialog_daily_picks_content(),
    testId: 'daily-picks-info-dialog',
  })
}
